export default "__VITE_ASSET__5UXA8qya__"